import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="border-b border-ink-600">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-32 text-center">
        <div className="font-display text-[10rem] leading-none text-copper">404</div>
        <h1 className="font-display text-4xl mb-4">Off the bench.</h1>
        <p className="text-steel-400 mb-8">That page doesn&apos;t exist or was never built.</p>
        <Link to="/" className="btn-copper">
          <ArrowLeft size={14} /> Back to Home
        </Link>
      </div>
    </main>
  );
}
